import type { Booking } from "@/types/domain";

export const bookingResponseDeadline = (booking: Pick<Booking, "expiresAt" | "ownerResponseDeadline">) =>
  new Date(booking.expiresAt ?? booking.ownerResponseDeadline ?? 0).getTime();

/** One key per owner-response window, so a re-requested booking pops up (and rings) again even if the
 * owner dismissed its previous window. */
export const bookingPopupKey = (booking: Pick<Booking, "id" | "confirmationAttempts">) => `${booking.id}:${booking.confirmationAttempts ?? 1}`;

/** Owner confirmed a confirm-before-payment booking and the guest still has to pay. */
// paymentDueAt is set when the owner confirms and cleared when the guest's app payment arrives.
export const isAwaitingGuestPayment = (booking: Pick<Booking, "confirmBeforePayment" | "bookingStatus" | "paymentDueAt">) =>
  Boolean(booking.confirmBeforePayment && booking.bookingStatus === "CONFIRMED" && booking.paymentDueAt);

export const isBookingResponseWindowOpen = (booking: Pick<Booking, "expiresAt" | "ownerResponseDeadline">, now = Date.now()) =>
  bookingResponseDeadline(booking) > now;
